import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import Paper from "../../ui/Paper"
import PaperTitle, { PaperFooter, TitleText } from "../../ui/PaperTitle"
import PropTypes from "prop-types"
import {
  fetchActions,
  selectActionsByContext,
  selectActionsByIds,
} from "../audit/slice"
import ActionsTable from "../audit/ActionsTable"
import Authed from "./Authed"

// Renders a table of the user account activity
const UserActivity = ({ id }) => {
  const dispatch = useDispatch()

  // we get any matching actions for this account
  const actionMatches = useSelector((state) =>
    selectActionsByContext(state, `account/${id}`)
  )
  // We get the full objects from the ids the match
  const actions = useSelector((state) =>
    selectActionsByIds(state, actionMatches?.ids || [])
  )

  useEffect(() => {
    dispatch(
      fetchActions({
        filter: {
          by_id: id,
        },
        page: {
          offset: 0,
          limit: 10,
        },
        context: `account/${id}`,
      })
    )
  }, [id])

  return (
    <Paper>
      <PaperTitle>
        <TitleText loadingState={actionMatches?._loadStatus || "idle"}>
          Recent activity for {id}
        </TitleText>
      </PaperTitle>
      <ActionsTable actions={actions} hideUserAccount={true} />
      {/*  TODO dont show this is not admin */}

      {actions.length != 0 &&
        actionMatches?.page?.total_count > actions?.length && (
          <PaperFooter>
            <Authed allowRoles={["admin"]}>
              <span>
                showing {actions?.length} of {actionMatches?.page?.total_count}{" "}
                <Link to={`/actions?by_id=${id}`}>view all</Link>
              </span>
            </Authed>
          </PaperFooter>
        )}
    </Paper>
  )
}

UserActivity.propTypes = {
  id: PropTypes.string,
}

export default UserActivity
